import ENDPOINTS from 'tradera-constants/endpoints';
import { CHECKOUT_ERRORS } from './checkout-errors';
import {
    axiosWithTokenRefresh,
    axiosConfigs,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';

const setErrorMessage = e => {
    if (e) {
        e.message = e.response?.data?.responseStatus?.errorCode;
        throw e;
    } else {
        throw new Error(CHECKOUT_ERRORS.GENERIC);
    }
};

export const getCheckout = async purchaseOrderId =>
    axiosWithTokenRefresh()
        .get(`${ENDPOINTS.ORDER_CHECKOUT_VIEW}/${purchaseOrderId}`, {
            withCredentials: true
        })
        .then(finalizeResponse())
        .catch(handleError());

export const getPaymentOptions = async (purchaseOrderId, selectedShippingId) =>
    axiosWithTokenRefresh()
        .get(`${ENDPOINTS.ORDER_CHECKOUT_PAYMENT_OPTIONS}/${purchaseOrderId}`, {
            params: {
                selectedShippingId
            },
            withCredentials: true
        })
        .then(finalizeResponse())
        .catch(handleError());

export const initializePayment = async formData =>
    axiosWithTokenRefresh()
        .post(
            ENDPOINTS.ORDER_CHECKOUT_INIT_PAYMENT,
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(e => {
            setErrorMessage(e);
        });

export const getPaymentStatus = async paymentAttemptId =>
    axiosWithTokenRefresh()
        .get(
            `${ENDPOINTS.ORDER_CHECKOUT_PAYMENT_STATUS}/${paymentAttemptId}`,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const completePayment = async formData =>
    axiosWithTokenRefresh()
        .post(
            ENDPOINTS.ORDER_CHECKOUT_COMPLETE_PAYMENT,
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const purchaseBin = async formData =>
    axiosWithTokenRefresh()
        .post(
            ENDPOINTS.ORDER_PURCHASE_BIN,
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const getBraintreeToken = async (purchaseOrderId, paymentOption) =>
    axiosWithTokenRefresh()
        .get(`${ENDPOINTS.ORDER_CHECKOUT_BRAINTREE}/${purchaseOrderId}`, {
            params: {
                paymentMethod: paymentOption
            },
            withCredentials: true
        })
        .then(finalizeResponse())
        .catch(handleError());

export const getExternalAuthData = async paymentAttemptId =>
    axiosWithTokenRefresh()
        .get(
            `${ENDPOINTS.ORDER_CHECKOUT_AUTH_DATA}/${paymentAttemptId}`,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const sendSwishSms = async formData =>
    axiosWithTokenRefresh()
        .post(
            '/shopping/swishapp2app/send',
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const requestCombinedShippingPrice = async formData =>
    axiosWithTokenRefresh()
        .post(
            ENDPOINTS.ORDER_CHECKOUT_REQUEST_COMBINED_PRICE,
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

export const cancelPayment = async formData =>
    axiosWithTokenRefresh()
        .post(
            ENDPOINTS.ORDER_CHECKOUT_CANCEL_PAYMENT,
            formData,
            axiosConfigs.authenticated
        )
        .then(finalizeResponse())
        .catch(handleError());

// Export object for Sinon stubbing
export default {
    getBraintreeToken,
    getCheckout,
    getExternalAuthData,
    getPaymentOptions,
    initializePayment,
    getPaymentStatus,
    completePayment,
    sendSwishSms,
    requestCombinedShippingPrice,
    cancelPayment
};
